export function foramtNumberToTwoDecimalPlaces(number) {
  const numAmount = parseFloat(number);
  
  if (isNaN(numAmount)) {
    throw new Error('Invalid payment amount format');
  }
  
  if (numAmount <= 0) {
    throw new Error('Payment amount must be greater than zero');
  }
  
  return numAmount.toFixed(2);
}